import React, {useState, useEffect} from 'react';
import Icon from '../../../layouts/common/icons/Icon';
import styles from '../../../styles/VenueSpaceModal.module.css';


const filterHideStyle = {
    display: "none"
  };
  
  const filterShowStyle = {
    position: "fixed",
    left: "0",
    top: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "#00000080",
    zIndex: 5100,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "8px"
  };

function NewModalOverlay({children,width,height,borderRadius,padding,isOverlayOpen,closeOverlay,isAutoclose,autoCloseConst = 2000,hideCloseButton}) {



    const [leftPanelActive, setLeftPanelActive] = useState(false)
    const [rightPanelActive, setRightPanelActive] = useState(false) 

    useEffect(() => {

        if(children?.length > 1){
            children.map(children => {
                if(children?.props.type === "left-panel"){
                    setLeftPanelActive(true)
                } else if (children?.props.type === "right-panel") {
                    setRightPanelActive(true)
                } else {
                    setLeftPanelActive(false)
                    setRightPanelActive(false)
                }
            })
        } else if(children?.length < 2) {
            return children;
        }

    }, [])

    useEffect(()=>{
    if(isAutoclose){
        setTimeout(()=>{
            closeOverlay()
        },autoCloseTimeOut ? autoCloseTimeOut : autoCloseConst)
    }
    },[])

    const subContainerStyling = {
        width: `${width ? width : "auto"}`, 
        height: `${height ? height : "auto"}`, 
        borderRadius: `${borderRadius ? borderRadius : 0}`, 
        padding: `${padding ? padding : 0}`, 
        backgroundColor: "#fff",
        display: "flex",
    }

    const leftPanel = (panelStatus) => {
        if(panelStatus){
            for(let i=0; i < children.length; i++){
                if(children[i].props.type === "left-panel"){
                    return children[i]
                }
            }
        }
    }

    const rightPanel = (panelStatus) => {
        if(panelStatus){
            for(let i=0; i < children.length; i++){
                if(children[i].props.type === "right-panel"){
                    return children[i]
                }
            }
        }
    }

  return (
    <div className={styles['styled-container']} style={isOverlayOpen ? filterShowStyle : filterHideStyle}>
        <div className={styles['styled-inner-container']} onClick={() => closeOverlay()} />
        <div className={`row ${styles['styled-subcontainer']}`} style={subContainerStyling}>
            {/* left panel */}
            {
                leftPanelActive && 
                    <div className={`col-lg-3 ${styles['venuespacemodal-leftpanel-container']}`}>
                        {leftPanel(leftPanelActive)}
                    </div>
            }

            {/* right panel */}
            {
                rightPanelActive && 
                    <div className={`col-lg-9 ${styles['venuespacemodal-rightpanel-container']}`}>
                        {rightPanel(rightPanelActive)}
                    </div>
            }
            {
                !leftPanelActive && !rightPanelActive && 
                    <div className={`col-lg-12 col-xs-12 col-md-12 ${styles['venuespacemodal-rightpanel-container']}`}>
                        {children}
                    </div>
            }
          {!hideCloseButton  && <div className={styles['modal-cross-icon']} onClick={() => closeOverlay()}></div>}
        </div>
    </div>
  )
}

export default NewModalOverlay;